<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="课程名称">
          <el-input
            style="width: 200px"
            v-model.trim="queryForm.courseName"
            clearable
            placeholder="请输入课程名称"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="学员姓名">
          <el-input
            style="width: 160px"
            v-model.trim="queryForm.memberName"
            clearable
            placeholder="请输入学员姓名"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            v-model="queryForm.auditStatus"
            clearable
            placeholder="请选择"
            style="width: 140px"
          >
            <el-option
              v-for="item in auditStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          :disabled="!selectedIds.length"
          :loading="batchLoading"
          @click="batchApprove"
          >批量通过</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="danger"
          :disabled="!selectedIds.length"
          :loading="batchLoading"
          @click="batchReject"
          >批量拒绝</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          :selectable="rowSelectable"
        ></el-table-column>
        <el-table-column
          align="center"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="courseName"
          label="课程名称"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="courseCode"
          label="课程编号"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="memberName"
          label="学员姓名"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="memberCode"
          label="学员编号"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="signUpTime"
          label="报名日期"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="courseStartTime"
          label="开课时间"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="auditStatus"
          label="审核状态"
          width="110"
        >
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="auditTagType(scope.row.auditStatus)"
              disable-transitions
            >
              {{ auditStatusLabel(scope.row.auditStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              plain
              round
              size="small"
              type="success"
              :disabled="Number(scope.row.auditStatus) !== 0"
              @click="approveOne(scope.row)"
              >通过</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              :disabled="Number(scope.row.auditStatus) !== 0"
              @click="rejectOne(scope.row)"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getCourseSignupAuditPage,
  approveCourseSignupAudit,
  rejectCourseSignupAudit
} from "@/api/course/signupAudit";

/** 审核状态：0待审核，1通过，2拒绝 */
const AUDIT_STATUS_OPTIONS = [
  { value: 0, label: "待审核" },
  { value: 1, label: "通过" },
  { value: 2, label: "拒绝" }
];

export default {
  name: "Review",
  data() {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        courseName: "",
        memberName: "",
        auditStatus: undefined
      },
      listData: [],
      totals: 0,
      loading: false,
      batchLoading: false,
      selectedIds: [],
      auditStatusOptions: AUDIT_STATUS_OPTIONS
    };
  },
  created() {
    this.search();
  },
  methods: {
    auditStatusLabel(val) {
      const hit = AUDIT_STATUS_OPTIONS.find(
        item => Number(item.value) === Number(val)
      );
      return hit ? hit.label : "-";
    },
    auditTagType(val) {
      const map = { "0": "warning", "1": "success", "2": "danger" };
      return map[String(val)] || "info";
    },
    rowSelectable(row) {
      return Number(row.auditStatus) === 0;
    },
    handleSelectionChange(rows) {
      this.selectedIds = (rows || [])
        .map(item => item.courseMemberRelevantId)
        .filter(id => id != null);
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.search();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNum = 1;
      this.search();
    },
    resetSelect() {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10,
        courseName: "",
        memberName: "",
        auditStatus: undefined
      };
      this.search();
    },
    async search() {
      this.loading = true;
      try {
        const params = { ...this.queryForm };
        Object.keys(params).forEach(key => {
          if (
            params[key] === "" ||
            params[key] === undefined ||
            params[key] === null
          ) {
            delete params[key];
          }
        });
        const result = await getCourseSignupAuditPage(params);
        const data = (result && result.data) || {};
        this.listData = data.rows || [];
        this.totals = Number(data.total) || 0;
        this.selectedIds = [];
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    async doAudit(ids, approve) {
      if (!ids || !ids.length) {
        this.$message.warning("请选择待审核记录");
        return;
      }
      const tip = approve ? "确定通过所选报名申请吗？" : "确定拒绝所选报名申请吗？";
      try {
        await this.$confirm(tip, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } catch (e) {
        return;
      }
      this.batchLoading = true;
      try {
        const payload = { courseMemberRelevantIds: ids };
        if (approve) {
          await approveCourseSignupAudit(payload);
          this.$message.success("已通过");
        } else {
          await rejectCourseSignupAudit(payload);
          this.$message.success("已拒绝");
        }
        this.search();
      } catch (e) {
      } finally {
        this.batchLoading = false;
      }
    },
    batchApprove() {
      this.doAudit(this.selectedIds, true);
    },
    batchReject() {
      this.doAudit(this.selectedIds, false);
    },
    approveOne(row) {
      this.doAudit([row.courseMemberRelevantId], true);
    },
    rejectOne(row) {
      this.doAudit([row.courseMemberRelevantId], false);
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/Review/index.vue